import './ManualHandlingIncidentTypes.scss'
import OverviewSection from '../../../../common/components/overviewSection/OverviewSection'
import ManualHandlingIncidentType from './manualHandlingIncidentType/ManualHandlingIncidentType'
import { IncidentCollectionRequestType } from './../../../../common/types/IncidentCollectionRequestType'
import IIncidentOverview from './../../../../common/interfaces/incidentOverview/IIncidentOverview'
import IIncidentOverviewIncidentType from '../../../../common/interfaces/incidentOverview/IIncidentOverviewIncidentType'
import React from 'react'
import IIncidentOverviewSeverityLevelIncident from '../../../../common/interfaces/incidentOverview/IIncidentOverviewSeverityLevelIncident'
import { currentLanguageFormatCode } from "../../../../configuration"

type ComponentProps = {
  domain:string
  incidentOverview:null|undefined|IIncidentOverview
  handleIncidentCollectionChangeRequest: (request:IncidentCollectionRequestType) => void
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
}

const ManualHandlingIncidentTypes = (props: ComponentProps) => {

  let countSeverityLevels:IIncidentOverviewSeverityLevelIncident|null|undefined = props.incidentOverview?.manualHandling?.countSeverityLevels
  const countSeverityLevel1 = countSeverityLevels?.severityLevel1 ?? 0
  const countSeverityLevel2 = countSeverityLevels?.severityLevel2 ?? 0
  const countSeverityLevel3 = countSeverityLevels?.severityLevel3 ?? 0
  const total = (countSeverityLevel1 + countSeverityLevel2 + countSeverityLevel3)
  let percentageLevel2 = 0
  let percentageLevel3 = 0
  let severityLevelWidthStyle = 'auto auto auto'

  const numberFormatter = new Intl.NumberFormat(currentLanguageFormatCode)
  
  if (total !== 0) {
    percentageLevel2 = ((countSeverityLevel2 / total) * 100)
    percentageLevel3 = ((countSeverityLevel3 / total) * 100)
    severityLevelWidthStyle = `${Math.floor(percentageLevel3)}% ${Math.floor(percentageLevel2)}% auto`
  }

  let incidentSum = 0

  if (props.incidentOverview?.manualHandling?.incidentTypes) {
    const incidentTypes:IIncidentOverviewIncidentType[] = props.incidentOverview?.manualHandling.incidentTypes
    for (const incidentType of (incidentTypes as IIncidentOverviewIncidentType[])) {
      incidentSum = incidentSum + incidentType.incidentCount
    } 
  }

  // TODO: Is this good?: In the below as child on the component ManualHandlingIncidentType, a fragment is its child. This is needed because this parent component OverviewSection has a Children property in props. Weird?Does all sub-componentsa need a child element, when a parent component demands children in its props?
  return (
    <OverviewSection
      contextID='manualHandlingIncidents' 
      incidentOverview={props.incidentOverview} 
      headerTitle='Hændelser' 
      headerStatus={incidentSum ? (numberFormatter.format(incidentSum) + ' stk.') : ''}
      handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}  
    >
      <div id='manual-handling-incidents'>

        <div id='manual-handling-incident-types' onClick={() => props.handleActiveUserGuideTopicNameChangeRequest('incidentOverviewIncidentTypes')}>
          {
            props.incidentOverview?.manualHandling?.incidentTypes &&
            props.incidentOverview?.manualHandling?.incidentTypes.map((incidentType:IIncidentOverviewIncidentType, indexIncidentType:number) => (
              <ManualHandlingIncidentType 
                key={incidentType.name} 
                domain={props.domain} 
                handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
                id={incidentType.name} 
                severityLevel={incidentType.severityLevel} 
                title={incidentType.title} 
                incidentCount={incidentType.incidentCount} 
                incidentSum={incidentSum} 
                handleIncidentCollectionChangeRequest={props.handleIncidentCollectionChangeRequest}
              >
                <React.Fragment />
              </ManualHandlingIncidentType>
            ))
          }
        </div>
        

        <div id='manual-handling-incident-severityLevels' style={{gridTemplateColumns: severityLevelWidthStyle}}>
          {
            [1, 2, 3].map((severityLevel) => {
              return (
                <React.Fragment key={severityLevel}>
                  <div 
                    id={'manual-handling-incident-severityLevel' + severityLevel.toString()} 
                    className='manual-handling-incident-severityLevel'
                    onClick={() => {
                      props.handleIncidentCollectionChangeRequest(
                        {
                          Title: ('Alvorlighedsniveau ' + severityLevel.toString()), 
                          Area: 'SeverityLevelRequest', 
                          Value: {NumberValue: severityLevel}, 
                          Timestamp: new Date()
                        }
                      )
                    }}>
                      {                      
                        severityLevel === 1 && (countSeverityLevels?.severityLevel1) ? numberFormatter.format(countSeverityLevels.severityLevel1) :
                          severityLevel === 2 && (countSeverityLevels?.severityLevel2) ? numberFormatter.format(countSeverityLevels.severityLevel2) :
                            severityLevel === 3 && (countSeverityLevels?.severityLevel3) ? numberFormatter.format(countSeverityLevels.severityLevel3) :
                              ''
                      }
                    </div> 
                  </React.Fragment>
                )
              })
          }
        </div>
      </div>
    </OverviewSection>
  )
}

export default ManualHandlingIncidentTypes